import React from 'react';

let nextGradientId = 0;

export default function BrandMark({ size = 32, title, className }) {
  const gradientIdRef = React.useRef();
  if (!gradientIdRef.current) {
    nextGradientId += 1;
    gradientIdRef.current = `brand-mark-gradient-${nextGradientId}`;
  }

  return (
    <svg
      aria-hidden={title ? undefined : true}
      aria-label={title}
      className={className}
      fill="none"
      height={size}
      role={title ? 'img' : undefined}
      viewBox="0 0 24 24"
      width={size}
      focusable="false"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id={gradientIdRef.current} x1="4" y1="3" x2="20" y2="22" gradientUnits="userSpaceOnUse">
          <stop stopColor="#10A56F" />
          <stop offset="1" stopColor="#0B7F83" />
        </linearGradient>
      </defs>
      <rect x="1.5" y="1.5" width="21" height="21" rx="5.25" fill={`url(#${gradientIdRef.current})`} />
      <path
        d="M18.25 5.55c-5.6.18-9.82 2.46-9.82 6.54 0 2.54 1.72 4.24 4.22 4.24 4.17 0 5.88-3.97 5.6-10.78Z"
        fill="white"
        fillOpacity="0.12"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
      />
      <path
        d="M6.45 18.55c2.35-3.43 5.14-6.04 8.64-7.72"
        stroke="white"
        strokeLinecap="round"
        strokeWidth="1.7"
      />
    </svg>
  );
}
